import { createSlice, PayloadAction } from '@reduxjs/toolkit';


export interface IUserContext {
  type: 'authenticated' | 'internal' | 'unauthenticated';
  name?: string;
  tenantId?: string;
  aadId?: string;
  userName?: string;
  preferredUserName?: string;
  loginSuccess?: boolean;
  internalUser?: boolean;
  isTenantAdmin?: boolean;
}

const initialState: IUserContext = {
  loginSuccess: false,
  type: 'unauthenticated',
  isTenantAdmin: false,
};


export const userContextSlice = createSlice({
  name: 'userContext',
  initialState,
  reducers: {
    updateUserContext: (state, action: PayloadAction<IUserContext>) => {
      state = {
        ...state,
        ...action.payload,
      };
      return state;
    },
  },
  selectors: {
    isTenantAdmin: (state) => state.isTenantAdmin,
    getTenantId: (state) => state.tenantId,
    isMicrosoftTenant: (state) => {
      return state.tenantId && state.tenantId.toLowerCase() === '72f988bf-86f1-41af-91ab-2d7cd011db47';
    },
    getAADId: (state) => state.aadId,
  }
});
